import React, { useEffect, useState } from "react";
import ModalBox, { ModalBody, ModalHeader } from "../../Modal/ModalBox";
import FormikWrapper from "../../FormikWrapper";
import "../../../assets/scss/property-information.scss";
import CustomerReportForm from "./CustomerReportForm";
import { customerReportSchema } from "../../../formValidation";
import { createCustomerReport } from "../../../services/customer/report";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers/allReducers";
import CustomerAuthModal from "../../Modal/Customer/Auth/CustomerAuthModal";

interface CustomerReportProps {
  initialData: {
    property_id?: string;
    project_id?: string;
    reel_id?: string;
  };
  closeModal: () => void;
  showModal: boolean;
}

const CustomerReport: React.FC<CustomerReportProps> = ({
  initialData,
  closeModal,
  showModal,
}) => {
  const { userInfo }: any = useSelector((state: RootState) => state.user);

  const initialValues = {
    reason: "",
    description: "",
  };

  const [loading, setLoading] = useState(false);
  const [formStep, setFormStep] = useState(1);

  const handleLoading = (data: boolean) => {
    setLoading(data);
  };

  const handleApiResponse = () => {
    setLoading(false);
    setFormStep(3);
  };

  const handleOnSubmit = (values: any) => {
    handleLoading(true);
    const apiData = {
      ...values,
      ...initialData,
    };

    createCustomerReport(apiData, handleLoading, handleApiResponse);
  };

  useEffect(() => {
    if (!showModal) {
      setFormStep(1);
      setLoading(false);
    }
  }, [showModal]);

  return (
    <div className="property-report-section">
      {userInfo ? (
        <ModalBox show={showModal} closeModal={closeModal}>
          <ModalHeader>
            <div className="py-3 border-b border-b-gray-400">
              <h2 className="font-medium text-2xl text-center">
                Report a Problem
              </h2>
            </div>
          </ModalHeader>
          <ModalBody>
            <div className="px-6 py-2">
              <FormikWrapper
                initialValues={initialValues}
                validationSchema={customerReportSchema[formStep - 1]}
                onSubmit={handleOnSubmit}
                buttonProps={{
                  isHide: true,
                }}
              >
                <CustomerReportForm
                  formStep={formStep}
                  loading={loading}
                  setFormStep={setFormStep}
                  handleDoneClick={closeModal}
                />
              </FormikWrapper>
            </div>
          </ModalBody>
        </ModalBox>
      ) : (
        <CustomerAuthModal modalShow={showModal} closeModal={closeModal} />
      )}
    </div>
  );
};

export default CustomerReport;
